import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { PrimaryButton, Input } from "../components/ui-bits";
import { ShippingContainerIcon, ArrowLeftIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      // Always succeed silently for security
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md border border-zinc-200 bg-white p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-zinc-950 text-white flex items-center justify-center">
            <ShippingContainerIcon size={26} weight="bold" />
          </div>
          <div>
            <div className="font-heading font-black text-xl tracking-tight">CARGO/SCAN</div>
            <div className="overline mt-0.5">Forgot password</div>
          </div>
        </div>

        {sent ? (
          <div className="text-sm text-zinc-700 space-y-3" data-testid="forgot-sent">
            <p>If an account exists for <strong>{email}</strong>, a reset link has been emailed. It expires in 1 hour.</p>
            <p className="text-xs text-zinc-500">Didn't get it? Check your spam folder. If you used SSO (Microsoft), use the "Sign in with Microsoft" button instead.</p>
            <Link to="/login" className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-950 mt-2">
              <ArrowLeftIcon size={12} /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-3">
            <p className="text-sm text-zinc-600 mb-3">Enter your email — we'll send a reset link.</p>
            <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full" placeholder="you@company.com" />
            <PrimaryButton type="submit" data-testid="forgot-submit" disabled={loading} className="w-full">
              {loading ? "Sending…" : "Send reset link"}
            </PrimaryButton>
            <Link to="/login" className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-950">
              <ArrowLeftIcon size={12} /> Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
